import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import Page from '../../components/layouts/page'
import List from '../../components/list'
import { Status } from '@bitcine/cinesend-theme/dist'

const ListPage = () => {
  const { airlineID, cycleID, listID } = useParams()
  const { data: cycle, isLoading } = useQuery(['cycles/', cycleID])
  const schemaId = cycle?.schema_id
  const { data: schema, isLoading: isSchemaLoading } = useQuery({
    queryKey: [`schemas/`, schemaId],
    enabled: !!schemaId,
  })
  const { data: collection } = useQuery(['collections/', listID])
  const root = `/airlines/${airlineID}/cycles/${cycleID}`

  return (
    <Page breadcrumbs={[{ text: 'Lists', to: `${root}/lists` }, { text: collection?.name }]}>
      <Status pending={isLoading || isSchemaLoading} error={!cycle || !schema || !collection}>
        <List schema={schema} disabled={!collection?.user_permissions?.['can_edit_items']} />
      </Status>
    </Page>
  )
}

export default ListPage
